import SectionWrapper from "../Section/SectionWrapper";
import SectionWrapperText from "../Section/SectionWrapperText";
import { PublishInfo } from "./PublishInfo";
import { ArticleSettings } from "../../SectionPage";

interface Props {
  articleSettings?: ArticleSettings;
}

export const PublishInfoSection: React.FC<Props> = ({ articleSettings }) => {
  if (!(
    articleSettings?.displayDates ||
    articleSettings?.author?.name ||
    articleSettings?.displayEstimatedReadTime ||
    articleSettings?.image ||
    articleSettings?.heading
  )) {
    return null;
  }

  return (
    <SectionWrapper
      anchorId={"publish-info"}
      backgroundColor={"transparent"}
      noImage={true}
      sx={{ my: "0rem !important" }}
    >
      <SectionWrapperText sxTextSectionContainer={{ py: "0rem !important" }}>
        <PublishInfo articleSettings={articleSettings} />
      </SectionWrapperText>
    </SectionWrapper>
  );
};
